import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { format } from "date-fns";
import { ISalRepFilter } from "./Filter";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Publish } from "../../requirement/Publish";
import { ILogin } from "../../../models/Login";
import { safeFormatDate } from "../../../models/DateFormatMapper";

interface Iprops {
    open: boolean,
    hideDialog: () => void,
    toast: any,
    salEffFilter: ISalRepFilter,
    salesID: number,
    resType: number,
    singleData: any,

}


export const SubTable = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<{}>, loading: boolean });
    const dt = useRef<any>(null);


    const exportCSV = () => {
        dt.current.exportCSV();
    };

    useEffect(() => {
        if (props.open) loadTableData();
    }, [props.open]);

    const loadTableData = async () => {
        setTableData({ tableData: [], loading: true });
        let response;
        response = await Fetch("NonPerformingPV/assignedpvInnerReport", "GET", null, `filter=${JSON.stringify(props.salEffFilter)}&salesID=${props.salesID}&resType=${props.resType}`, props.toast);
        if (response) {
            const data: Array<{ sn: number }> = await response.json();
            setTableData({ tableData: data, loading: false });

        }
    }

    const AssignedOn = (rowData: any) => {
        let date;
        if (rowData.createdon) date = format(new Date(rowData.createdon), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const ConverteddOn = (rowData: any) => {
        let date;
        if (rowData.firstConvertedOn) date = format(new Date(rowData.firstConvertedOn), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const onHide = () => {
        props.hideDialog();
    }
    console.log(props.singleData.user_Name)
    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0 text-lg font-semibold text-gray-900">
                <span className="text-blue-600">{props.singleData.user_Name}</span> |{" "}
                <span className="text-gray-600">{props.singleData.branchName}</span>{" "}
                {props.resType === 1 ? (
                    <span className="text-green-700">Assigned PV Details</span>
                ) : (
                    <span className="text-purple-700">Assigned Converted PV Details</span>
                )}
            </h5>
            <Button label="Export" icon="pi pi-upload" className="p-button-help w-8rem mr-3" onClick={exportCSV} />
        </div>
    );

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header={header} modal className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }} exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                ref={dt} size="small" stripedRows showGridlines scrollable scrollHeight="70vh"
                value={tableData.tableData}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                {props.resType === 1 && <Column field="vendor_Company_Name" header="Vendor Company" sortable />}
                {props.resType === 1 && <Column field="contact_Person_Name" header="Contact Person" sortable />}
                {/* {props.resType === 1 && <Column field="user_name" header="Sales Manager" sortable />}
                {props.resType === 1 && <Column field="branchName" header="Branch Name" sortable />} */}
                {/* {props.resType === 1 && <Column field="createdon" header="Assigned On" body={AssignedOn} sortable />} */}
                {props.resType === 1 && <Column field="createdon" header="Assigned On" body={(rowData: any) => safeFormatDate(rowData.createdon, 'dd/MM/yyyy', DateFormat)} sortable />}
                {props.resType === 1 && <Column field="isFollowupMail" header="Follow-Up Mail" sortable body={(rowData) => <p style={{ color: rowData.isFollowupMail ? "blue" : "red" }}>{rowData.isFollowupMail ? "YES" : "NO"}</p>} />}
                {props.resType === 1 && <Column field="isFollowupOnPhone" header="Follow-Up Call" body={(rowData) => <p style={{ color: rowData.isFollowupOnPhone ? "blue" : "red" }}>{rowData.isFollowupOnPhone ? "YES" : "NO"}</p>} sortable />}

                {props.resType != 1 && <Column field="vendor_Company_Name" header="Vendor Company" sortable />}
                {props.resType != 1 && <Column field="contact_Person_Name" header="Contact Person" sortable />}
                {/* {props.resType != 1 && <Column field="createdon" header="Assigned On" body={AssignedOn} sortable />} */}
                {props.resType != 1 && <Column field="createdon" header="Assigned On" body={(rowData: any) => safeFormatDate(rowData.createdon, 'dd/MM/yyyy', DateFormat)} sortable />}
                {/* {props.resType != 1 && <Column field="firstConvertedOn" header="Converted On" body={ConverteddOn} sortable />} */}
                {props.resType != 1 && <Column field="firstConvertedOn" header="Converted On" body={(rowData: any) => safeFormatDate(rowData.firstConvertedOn, 'dd/MM/yyyy', DateFormat)} sortable />}


                {props.resType != 1 && <Column field="req" header="#Req" sortable />}
                {props.resType != 1 && <Column field="sub" header="#Sub" sortable />}
                {props.resType != 1 && <Column field="subEnd" header="#SubEnd" sortable />}
                {props.resType != 1 && <Column field="eci" header="#ECI" sortable />}
                {props.resType != 1 && <Column field="po" header="#PO" sortable />}

            </DataTable>
        </Dialog>
    );
}
